import React from "react";

const Loading = () => (
	<span>
		Loading…
	</span>
);

export default Loading;
